import { render, staticRenderFns } from "./ProofExpansionPanel.vue?vue&type=template&id=1b863902"
import script from "./ProofExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ProofExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports